import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Tooltip, Chip, CircularProgress, Box
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

const StatusChip = ({ status }) => {
    const statusConfig = {
        M: { label: 'Master', color: 'success' },
        C: { label: 'Funcionário', color: 'warning' },
    };

    const config = statusConfig[status] || { label: 'Não informado', color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default function TabelaUsuarios({ usuarios, onEdit, onDelete, carregandoState }) {
    const { carregando, deletingId } = carregandoState;

    if (carregando === 'fetching' || carregando === 'searching') {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
    }

    if (usuarios.length === 0) {
        return <Box sx={{ textAlign: 'center', p: 5 }}>Nenhum usuário encontrado.</Box>
    }

    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="tabela de máquinas">
                <TableHead>
                    <TableRow sx={{ '& th': { fontWeight: 'bold' } }}>
                        <TableCell>Código</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell align="center">Tipo</TableCell>
                        <TableCell align="center">Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {usuarios.map((users) => (
                        <TableRow key={users.id} hover>
                            <TableCell>{users.id}</TableCell>
                            <TableCell>{users.nome}</TableCell>
                            <TableCell align="center">
                                <StatusChip status={users.tipo} />
                            </TableCell>
                            <TableCell align="center">
                                <Tooltip title="Editar">
                                    <IconButton color="primary" onClick={() => onEdit(users)}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Excluir">
                                    <IconButton
                                        color="error"
                                        onClick={() => onDelete(users.id)} disabled={deletingId === users.id && carregando !=="idle"}
                                    >
                                        {deletingId === users.id && carregando !=="idle" ? <CircularProgress size={22} color="inherit" /> : <DeleteIcon />}
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}